


function addToken(headers: any, accessToken: String): any {
    headers = {
        ...headers,
        'Authorization' :  "Bearer " + accessToken
    }
  return headers;
}

export async function uisFetch(
  accessToken: String,
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const url = input instanceof Request ? input.url : 
              input instanceof URL ? input.toString() : input;
  

  
    const processedUrl = url; 
    const withToken = {
        ...init,
        headers : addToken(init?.headers,accessToken)
       
    };

    
  
  return fetch(processedUrl, withToken);
}

export default uisFetch;